import React from 'react';

export const BryInput = React.forwardRef(({
  label,
  error,
  helpText,
  icon: Icon,
  type = 'text',
  className = '',
  id,
  required,
  ...props
}, ref) => {
  const inputId = id || (label ? `input-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined);

  return (
    <div className={`bry-form-group ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="bry-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <div style={{ position: 'relative', width: '100%' }}>
        {Icon && (
          <div style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: 'var(--bry-text-tertiary)', pointerEvents: 'none' }}>
            <Icon size={18} />
          </div>
        )}
        <input
          ref={ref}
          id={inputId}
          type={type}
          className={`bry-input ${error ? 'bry-input-error' : ''}`}
          style={Icon ? { paddingLeft: 42 } : {}}
          {...props}
        />
      </div>
      {error && <span className="bry-error-text">{error}</span>}
      {!error && helpText && <span className="bry-help-text">{helpText}</span>}
    </div>
  );
});

BryInput.displayName = 'BryInput';
